import React from "react";
import "./CredentialPoints.css";

const PointBadgeCheckpoint = ({ id }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        flexDirection: "column",
        position: "relative",
        textAlign: "center",
      }}
    >
      <div
        style={{
          outline: "3px solid #3361cf",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        {id}
      </div>

      <svg
        width="7"
        height="6"
        viewBox="0 0 7 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: "absolute",
          bottom: "-8px",
        }}
      >
        <path
          d="M3.89664 5.25C3.70419 5.58333 3.22307 5.58333 3.03062 5.25L-0.000469637 -1.28846e-07L6.92773 4.76837e-07L3.89664 5.25Z"
          fill="#3361CF"
        />
      </svg>
    </div>
  );
};

const BadgeGroup = ({ badge, index }) => {
  return (
    <div className="cp__badge_group">
      <div className="cp__badge_item">
        <img alt="badge" src={badge.badgeImage} />
      </div>
      <p className="cp__badge_name">{badge.badgeName}</p>
      <div className="cp__timeline_checkpoint">
        <PointBadgeCheckpoint id={index + 1} />
      </div>
      <p className="cp__badge_description">
        To get a {badge.badgeName} badge you have to earn {badge.valueThreshold}{" "}
        points
      </p>
    </div>
  );
};

const CredentialPoints = ({ points }) => {
  const badgeCount = points?.length || 1;
  return (
    <div className="cp__container">
      <div
        className="cp__badges_wrapper"
        style={{ "--badge-count": badgeCount }}
      >
        <div className="cp__timeline"></div>
        {points?.map((badge, index) => {
          return <BadgeGroup key={badge?._id} badge={badge} index={index} />;
        })}
      </div>
    </div>
  );
};

export default CredentialPoints;
